import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { useTranslation } from "react-i18next";
import styles from "./AudioSpeedSlider.module.css";

interface SpeedSliderProps {
    initialValue?: number;
    min?: number;
    max?: number;
    step?: number;
    onChange?: (value: number) => void;
}

const SpeedSlider: React.FC<SpeedSliderProps> = ({ initialValue = 1, min = 0.5, max = 2, step = 0.1, onChange }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const [value, setValue] = useState<number>(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    const handleSliderChange = (val: number | number[]) => {
        const newValue = Array.isArray(val) ? val[0] : val;
        setValue(newValue);
        onChange?.(newValue);
    };

    return (
        <div className={styles.root}>
            <div className={styles.labels}>
                <span className={styles.label}>{t("slower")}</span>
                <span className={styles.value}>{value.toFixed(2)}</span>
                <span className={styles.label}>{t("faster")}</span>
            </div>
            <div className={styles.slider}>
                <Slider min={min} max={max} step={step} value={value} onChange={handleSliderChange} />
            </div>
        </div>
    );
};

export default SpeedSlider;
